import StepShell, { Question } from '../StepShell'
import Field, { fieldInputClass } from '../Field'

export default function StepContact({ answers, dispatch, active }) {
  const set = (field) => (e) => dispatch({ type: 'SET_ANSWER', field, value: e.target.value })
  return (
    <StepShell active={active} step={1}>
      <Question>Who's reserving?</Question>
      <Field label="Company" htmlFor="reserve-company">
        <input id="reserve-company" name="company" className={fieldInputClass} type="text" placeholder="Acme AI" value={answers.company || ''} onChange={set('company')} />
      </Field>
      <Field label="Your name" htmlFor="reserve-name">
        <input id="reserve-name" name="name" className={fieldInputClass} type="text" placeholder="Jane Founder" value={answers.name || ''} onChange={set('name')} />
      </Field>
      <Field label="Work email" htmlFor="reserve-email">
        <input id="reserve-email" name="email" className={fieldInputClass} type="email" placeholder="jane@acme.ai" value={answers.email || ''} onChange={set('email')} />
      </Field>
    </StepShell>
  )
}
